<!-- autocomplete diagnostic master -->

<!-- diagnostic-master.autocomplete.component.html -->

<label *ngIf="label" [attr.for]="inputId">
  {{ label }} <span *ngIf="showRequiredIndicator" class="text-danger">*</span>
</label>


<input [id]="inputId"
      [formControl]="diagnosticMasterFormControl"
      [placeholder]="placeholder"
      matInput
      type="text"
      [matAutocomplete]="auto"
      (input)="onChangefilterDiagnosticMaster()"
      (blur)="clearDiagnosticNameIfNotSelected()"
      [ngClass]="{'border-error': showRequiredError}">

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onDiagnosticItemSelected($event)">
  <mat-option *ngFor="let item of diagnosticMasterList" [value]="item">
    {{ applyMaskSelection(item) }}
  </mat-option>
</mat-autocomplete>

<mat-error *ngIf="showRequiredError">
  {{ errorStr }}
</mat-error>
